import { useEffect, useState } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import PublicRoute from './View/Public/Route';
import UserRoute from './View/User/Route'
import { ContextProvider } from './View/Helper/Context'
import { isLogin } from './View/Helper/Functions'
import Maintenance from './View/Helper/Maintenance'
import './View/App.css';
import { ToastContainer } from 'react-toastify';

const AppRoute = createBrowserRouter([...PublicRoute, ...UserRoute])

export default function App() {
  const [, forceUpdate] = useState(0);
  useEffect(() => AppRoute.subscribe(() => forceUpdate((n) => n + 1)), []);

  const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  const bypassUser = process.env.REACT_APP_MAINTENANCE_BYPASS_USER;
  const { id = null } = isLogin() || {};
  const isBypassed = bypassUser && id === bypassUser;
  const isLoginPage = AppRoute.state.location.pathname === '/login';

  if (maintenanceMode && !isBypassed && !isLoginPage) {
    return (<>
      <ToastContainer />
      <Maintenance />
    </>)
  }

  return (<>
    <ToastContainer />
      <ContextProvider>
        <RouterProvider router={AppRoute} />
      </ContextProvider>
  </>)
}
